
import { Component, Emit, Vue, Prop } from 'vue-property-decorator'

@Component
export default class AppTableDefaultRow extends Vue {
    @Prop() private content!: Iterable<any>
}
